module.exports = __webpack_public_path__ + "img/left.f436f22a.png";